import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, mediaUrl, type CatalogRow } from "../api.ts";
import { money } from "../format.ts";
import { Act, Empty } from "../ui.tsx";

export const LISTING_STATUS: Record<string, string> = { draft: "Brouillon", pending_review: "À valider", published: "En ligne", unlisted: "Hors ligne", suspended: "Suspendu" };
const FILTERS = [["", "Tous"], ["pending_review", "À valider"], ["published", "En ligne"], ["draft", "Brouillons"], ["suspended", "Suspendus"]] as const;

export function Catalogue() {
  const [rows, setRows] = useState<CatalogRow[] | null>(null);
  const [status, setStatus] = useState("");
  const [owner, setOwner] = useState("");
  const load = () => {
    const q = new URLSearchParams();
    if (status) q.set("status", status);
    if (owner) q.set("ownerType", owner);
    api<CatalogRow[]>(`/v1/staff/listings?${q}`).then(setRows).catch(() => setRows([]));
  };
  useEffect(load, [status, owner]);

  return (
    <section>
      <header className="pagehead">
        <h1>Catalogue</h1>
        <p className="muted small">Les biens Sekani et ceux des propriétaires partenaires.</p>
        <div className="quick" style={{ marginTop: 12 }}>
          {FILTERS.map(([v, l]) => <button key={v} className={`chip ${status === v ? "on" : ""}`} onClick={() => setStatus(v)}>{l}</button>)}
          <select value={owner} onChange={(e) => setOwner(e.target.value)} aria-label="Propriétaire">
            <option value="">Tous les propriétaires</option><option value="platform">Biens Sekani</option><option value="host">Partenaires</option>
          </select>
          <Link to="/catalogue/new" className="btn" style={{ display: "inline-flex", alignItems: "center", textDecoration: "none" }}>Nouveau bien Sekani</Link>
        </div>
      </header>
      {rows && rows.length === 0 && <Empty>Aucun bien.</Empty>}
      <ul className="rows">
        {rows?.map((l) => (
          <li key={l.id} className="row listing-row">
            <Link to={`/catalogue/${l.id}`} className="main thumbrow">
              <span className="thumb">{l.coverKey ? <img src={mediaUrl(l.coverKey)} alt="" loading="lazy" /> : null}</span>
              <span className="who">
                <b>{l.title.fr}</b>
                <span className="muted small">{l.cityKey} · {l.ownerType === "platform" ? "Sekani" : l.hostName ?? "Partenaire"} · {l.maxGuests} pers.</span>
              </span>
            </Link>
            <div className="side"><b className="num">{money(l.basePriceMinor, l.currency)}</b><span className="pill sm">{LISTING_STATUS[l.status] ?? l.status}</span></div>
            {l.status === "pending_review" && (
              <div className="quick">
                <Act run={async () => { await api(`/v1/staff/listings/${l.id}/approve`, { body: {} }); load(); }}>Publier</Act>
              </div>
            )}
          </li>
        ))}
      </ul>
    </section>
  );
}
